import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, CircularProgress } from '@mui/material';
import Modal from 'components/modal';
import { commonStyles as style } from 'assets/style';
import ProvisioningStyles from 'pages/provisioning/virtual-service/style';
import Btn from 'components/button';

const VSDrawer = ({ isOpen, isSubOpen, title, subHeader, handleDrawerAction, children, isSaveLoading }) => {
    const closeButton = () => (
        <Btn
            className="btn-disabled custom-btn"
            variant="contained"
            sx={style.modalSaveButton}
            onClick={() => handleDrawerAction('save', isSubOpen)}
            data-testid="save-btn"
        >
            {isSaveLoading ? <CircularProgress color="inherit" size={16} sx={{ color: '#ffffff' }} /> : 'Save'}
        </Btn>
    );
    const cancelButton = () => (
        <Btn
            className="custom-btn"
            sx={style.modalCancelButton}
            variant="outlined"
            onClick={() => handleDrawerAction('cancel', isSubOpen)}
            data-testid="cancel-btn"
        >
            Cancel
        </Btn>
    );
    React.useEffect(() => {
        const element = document.getElementById('rwc');
        if (element !== null) {
            if (isOpen) {
                document.getElementById('rwc').style.display = 'none';
            } else {
                document.getElementById('rwc').style.display = 'block';
            }
        }
    }, [isOpen?.toString()]);

    return (
        <Modal
            open={isOpen}
            width="50%"
            title={title}
            subHeader={subHeader}
            primaryButton={closeButton()}
            secondaryButton={cancelButton()}
            handleClose={() => handleDrawerAction('cancel', isSubOpen)}
        >
            <>
                <Box style={ProvisioningStyles.tags.wrapper}>
                    <Box sx={ProvisioningStyles.tags.contentWrapper}>
                        {subHeader ? (
                            <Typography component="h3" sx={ProvisioningStyles.tags.subHeader}>
                                {subHeader}
                            </Typography>
                        ) : null}
                        {children}
                    </Box>
                    <Box className="footer" sx={ProvisioningStyles.tags.actionWrapper} gap={2}>
                        {closeButton()}
                        {cancelButton()}
                    </Box>
                </Box>
            </>
        </Modal>
    );
};

VSDrawer.propTypes = {
    isOpen: PropTypes.bool,
    isSubOpen: PropTypes.bool,
    handleDrawerAction: PropTypes.func.isRequired,
    title: PropTypes.string,
    subHeader: PropTypes.string,
    children: PropTypes.any,
    isSaveLoading: PropTypes.bool,
};

VSDrawer.defaultProps = {
    title: '',
    isOpen: true,
    isSubOpen: false,
    children: <></>,
    subHeader: null,
    isSaveLoading: false,
};

export default React.memo(VSDrawer);
